export const WC_PROJECT_ID = 'c3e6053f10efbb423808783ee874cf6a' // Default WalletConnect project ID for IDKit
